/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientTargetModel } from '../../models/patient-target-model';

export interface DuplicatePatientTarget$Params {
  patientTargetID?: number;
}

export function DuplicatePatientTarget(http: HttpClient, rootUrl: string, params?: DuplicatePatientTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientTargetModel>> {
  const rb = new RequestBuilder(rootUrl, DuplicatePatientTarget.PATH, 'post');
  if (params) {
    rb.query('patientTargetID', params.patientTargetID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientTargetModel>;
    })
  );
}

DuplicatePatientTarget.PATH = '/api/Supervisor/DuplicatePatientTarget';
